import React from 'react';
import { Grid } from '@material-ui/core';
import { DataGridWithHeaders } from '@orijinworks/frontend-commons';
import { useStyles } from './manage-locations.styles';
import { useManageLocations } from '../../hooks/useManageLocations';
import { withRouter } from '../../../../../util/router-compatibility';
import { columns } from '../../config/columns.config';

const AddLocation = React.lazy(() => import('../../../../../components/manage-locations/add/addLocation'));

export const ManageLocationsV2 = ({ history }) => {
  const classes = useStyles();

  const {
    pagination: { pageSize, handlePageChange, handlePageSizeChange },
    selection: { handleSelectionChange },
    loadingState: { dataLoading, getLocations, lastRefreshed, formatLastRefreshedTime },
    locationData: { locations, updateLocations },
  } = useManageLocations({ history });

  return (
    <Grid container component="div" className={classes.content}>
      <Grid container item className={classes.addLocationContainer}>
        <AddLocation updateLocations={updateLocations} />
      </Grid>

      <Grid item xs={12} className={classes.gridContainer}>
        <DataGridWithHeaders
          title="Locations"
          subtitle={formatLastRefreshedTime(lastRefreshed)}
          dataGridProps={{
            columns,
            data: [...locations],
            pageSize,
            pageSizeOptions: [20, 50, 100],
            paginationMode: 'client',
            isLoading: dataLoading,
            onRefreshHandler: getLocations,
            onSelectionChange: handleSelectionChange,
            onPageChange: handlePageChange,
            onPageSizeChange: handlePageSizeChange,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default withRouter(ManageLocationsV2);
